module.exports = __webpack_public_path__ + "img/epr-price_small.3c342875.jpg";